; (function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection = APP.module('Collection');

	Collection.MenuItems = Collection.MenuItems.extend({
		default_items: [
			{
				method_name: "gamesList",
				path: "tipping",
				name: "Tipping"
			},
			{
				method_name: "leaguesList",
				path: "tipping/leagues",
				name: "Comps",
				sub_menu: false,
				sub_menus_list: [
					{
						breadcrumb: {
							path: 'tipping',
							text: ''
						},
						menu: [
							{
								method_name: "leaguesList",
								path: "tipping/leagues",
								name: "My Leagues"
							},
							{
								method_name: "leaguesCreate",
								path: "tipping/leagues/create",
								name: "Create a League"
							},
							{
								method_name: "leaguesJoin",
								path: "tipping/leagues/join",
								name: "Join a League"
							}
						]
					}
				]
			},
			{
				method_name: "rankings",
				path: "tipping/rankings",
				name: "Rankings"
			},
			{
				method_name: "gauntlet",
				path: "tipping/gauntlet",
				name: "Gauntlet",
				className: "js-gauntlet-coming-soon-popup"
			},
			{
				method_name: "prizes",
				path: "help/prizes",
				name: "Prizes"
			},
			{
				method_name: "faqs",
				path: "help/faqs",
				nested_method_name: ['rules', 'terms', 'contactUs', 'guidelines'],
				name: 'Help',
				type: "afl"
			},
			{
				method_name: "",
				path: "http://jmc.com.au/",
				external: true,
				name: 'Visit JMC'
			},
			{
				method_name: false,
				path: "#account",
				nested_method_name: ['notifications', 'socialConnection', 'changePassword', 'account'],
				name: '',
				external: true,
				icon: "<i class='fa fa-cog'></i>",
				className: 'account-dropdown',
				sub_menu: false,
				sub_menus_list: [
					{
						path: "account",
						name: "Account Settings1",
						type: 'afl'
					}
				]
			}
		],

		off_season_items: [
			{
				method_name: "prizes",
				path: "off-season/help/prizes",
				name: "Prizes"
			}
		],

		defaults: {},

		setDefaults: function () {

			this.reset($.extend(true, [], CONFIG.OFF_SEASON ? this.off_season_items : this.default_items));

			return this;
		}
	});
}(window, APP, Backbone, Marionette, $, _));
